// Array.prototype.group ponyfill
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/group

type OutputMap<KEY extends string | number, VALUE> = string extends KEY
	? { [key: string]: VALUE[] }
	: number extends KEY
		? { [key: number]: VALUE[] }
		: { [key in KEY]?: VALUE[] }

export default function array_group<KEY extends string | number, VALUE>(arr: VALUE[], fn: (t: VALUE) => KEY): OutputMap<KEY, VALUE> {
	const memo: OutputMap<KEY, VALUE> = {}
	return arr.reduce((memo, e) => {
		const key = fn(e)

		if (key in memo) {
			// @ts-expect-error
			memo[key].push(e)
		} else {
			// @ts-expect-error
			memo[key] = [ e ]
		}

		return memo
	}, memo)
}
